/**
 * Feed daily-goal streak API — web counterparts of the iOS calls used by
 * FeedHeaderProgress (client-native/src/api/Api.ts:359-398):
 *   GET  /auth/dailylistening?date=YYYY-MM-DD → GetDailyListeningResponse
 *   POST /auth/incrementstreak                → PostIncrementStreakResponse
 *
 * Verify: curl -H "Authorization: Bearer $TOKEN" \
 *   "$BACKEND/auth/dailylistening?date=$(date +%F)"
 */
import {
  GetDailyListeningResponse,
  PostIncrementStreakResponse,
} from "@shared_types";
import { axiosInstance, AuthFuncParams } from "@/api/Api";

export async function getDailyListening({
  authToken,
}: AuthFuncParams<void>): Promise<GetDailyListeningResponse> {
  // Client's local date in YYYY-MM-DD, matching iOS getDailyListening — the
  // server resolves "today" per-client so day boundaries follow the device.
  const now = new Date();
  const localDate = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;

  const response = await axiosInstance.get<GetDailyListeningResponse>(
    "/auth/dailylistening",
    {
      params: { date: localDate },
      headers: { Authorization: `Bearer ${authToken}` },
    },
  );
  return response.data;
}

export async function postIncrementStreak({
  authToken,
}: AuthFuncParams<void>): Promise<PostIncrementStreakResponse> {
  const response = await axiosInstance.post<PostIncrementStreakResponse>(
    "/auth/incrementstreak",
    undefined,
    {
      headers: { Authorization: `Bearer ${authToken}` },
    },
  );
  return response.data;
}
